import React, { useState } from 'react';
import { SymbolTextBox } from '../Input/SymbolTextbox';
import GeneralButton from '../Button/GeneralButton';
import { CoustomTableHeaderProps } from '../Table/CoustomTable';
import { states } from '../../pages/LocationGroup/LocationGroupRecord';
import { useNavigate } from 'react-router-dom';
import { NewToggleSwitch } from '../FormElement/ToggleButton';
import { LocationGroupForm } from '../../models/LocationGroup';
import { useStore } from '../../stores/store';
import { observer } from 'mobx-react-lite';
import TitlePath, { Page } from '../TitlePath/TitlePath';

export const compLabel = {
    width: '35px', padding: '1.5%', marginRight: '10%'
}

export const components = {
    height: '35px',
    paddingTop: '8px',
    paddingRight: '16px',
    margin: '10px'
}

interface Props {
    buttonChoice: string;
    activeState: string;
    setState: (str: string) => void;
    setButtonChoice: (str: string) => void;
    options: Array<CoustomTableHeaderProps>;
    statesArray: states[];
    setactiveState: (x: string) => void;
    lastPages?: Page[];
    title: string;
    state?: string;
}

export default observer(function LocationGroupHeader({ activeState, state, buttonChoice, title, lastPages, setState, setButtonChoice, options, statesArray, setactiveState }: Props) {
    const navigate = useNavigate();
    const { locationGroupStore } = useStore();
    const { filterPlaceholder, ChangePlaceHolder } = locationGroupStore;

    const [record, setRecord] = useState<LocationGroupForm>({
        projectId: 0,
        name: '',
        status: false,
        remark: ''
    });

    const filterProps = {
        placeholder: filterPlaceholder,
        IconLeft: "/assets/button/filterProp/filterLeft.png",
        IconRight: "/assets/button/filterProp/filterRight.png",
    }

    const createLocationGroup = () => {
        navigate('/locationGroup/create');
    }

    const createButton = { title: 'Create New Location Group', imgSrc: '/assets/button/recAdd.png', Click: createLocationGroup }

    return (
        <div className='flex flex-col gap-4'>
            <TitlePath currentTitle={title} lastPages={lastPages} />

            <div className='flex flex-col lg:flex-row justify-between gap-3'>
                <div className='flex'>
                    <SymbolTextBox
                        defaultValue={state}
                        buttonChoice={buttonChoice}
                        changePlaceholderValue={ChangePlaceHolder}
                        setactiveState={setactiveState}
                        options={options}
                        IconLeft={filterProps.IconLeft}
                        IconRight={filterProps.IconRight}
                        placeholder={filterProps.placeholder}
                        onChange={(e) => setState(e.target.value)}
                        statesArray={statesArray}
                        setButtonChoice={setButtonChoice}
                    />
                </div>
                <div className='flex flex-col md:flex-row gap-3'>
                    <div className='w-full flex items-center'>
                        <span>Status:</span>
                        <NewToggleSwitch value={activeState === "Active" ? true : undefined} setActiveState={setactiveState} record={record} setRecord={setRecord} name={"activeStatus"} />
                    </div>
                    <div className='w-full'>
                        <GeneralButton title={createButton.title} imgSrc={createButton.imgSrc} handleClick={createLocationGroup} />
                    </div>
                </div>
            </div>
        </div>
    );
});

